import React from "react";
import { Link } from "react-router-dom";
import TopicOne from "../../market-contents/indices-market-contents/TopicOne";

const IndicesMarketContentOne = () => {
  return (
    <>
      {/* Add the TopicOne component here */}
      <TopicOne />

      <div className="how__work__market">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
              <div className="content-left">
                <h3>Access Top Global Indices</h3>
                <p>
                  Trade major benchmarks like the S&amp;P 500, NASDAQ, FTSE 100,
                  and DAX, all in one platform.
                </p>

                <h3>Low Spreads &amp; High-Speed Execution</h3>
                <p>
                  Benefit from institutional-grade pricing and ultra-fast order
                  execution even in volatile markets.
                </p>

                <h3>Go Long or Short with Ease</h3>
                <p>
                  Capitalize on both rising and falling markets using flexible
                  CFD trading options.
                </p>

                <h3>Advanced Tools &amp; Analytics</h3>
                <p>
                  Make informed decisions with integrated charts, market data,
                  and expert insights.
                </p>

                {/* <Link
                  className="slide__btn dg__btn"
                  to={process.env.PUBLIC_URL + "/company/contact"}
                >
                  Register now
                </Link> */}
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
              <div className="thumb-right">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/markets/indices_cfd/indices_1.png"
                  }
                  alt="computer images"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default IndicesMarketContentOne;
